/* EmptyState.tsx */
import React from 'react';

type EmptyStateProps = {
  title?: string;
  icon?: string; // clase PrimeIcons, ej: "pi pi-info-circle"
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No hay datos para mostrar…',
  icon = 'pi pi-info-circle',
}) => {
  return (
    <div
      className="flex flex-column align-items-center justify-content-center text-center w-full p-4"
      style={{ minHeight: 200 }}
    >
      <i className={`${icon} text-3xl mb-3 text-blue-500`} />
      <span className="text-xl font-bold text-900">{title}</span>
    </div>
  );
};

export default EmptyState;
